import { render, staticRenderFns } from "./btn-link.vue?vue&type=template&id=03d1a20c&"
import script from "./btn-link.vue?vue&type=script&lang=js&"
export * from "./btn-link.vue?vue&type=script&lang=js&"
import style0 from "./btn-link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports